<template>
  <footer class="block-footer footer" :class="[device_platform]">
    <div class="container">
      <p class="footer__text">ФитнесМания © 2021</p>
    </div>
  </footer>
</template>

<script>
import Mixin from "../common/mixin";
export default {
  name: "block-footer",
  mixins: [Mixin],
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.footer {
  width: 100%;
  padding: 16px 0;
  position: relative;
  background-color: #fff;

  &__text {
    font-size: 14px;
    color: #a0a0a0;
    letter-spacing: 0.05em;
    text-align: center;
  }
  &__phone {
    position: absolute;
    top: 50%;
    left: 6%;
    transform: translateY(-50%);
  }
}
@media (max-width: 476px) {
  .footer {
    &__phone {
      position: static;
      text-align: center;
      display: block;
    }
  }
}
</style>
